<template>
  <div class="routes-page">
    <div class="page-header">
      <h2>线路列表</h2>
      <div class="header-actions">
        <el-button type="primary" @click="handleCreate">
          <i class="el-icon-plus"></i> 创建线路
        </el-button>
      </div>
    </div>
    <div class="routes-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="上架" name="1"></el-tab-pane>
        <el-tab-pane label="下架" name="0"></el-tab-pane>
        <el-tab-pane label="待发布" name="2"></el-tab-pane>
      </el-tabs>
      <el-table :data="routes" style="width: 100%" v-loading="loading" border>
        <el-table-column label="线路名称" min-width="250">
          <template slot-scope="scope">
            <div class="route-info">
              <div class="route-image" v-if="scope.row.image">
                <img :src="scope.row.image" :alt="scope.row.productName" />
              </div>
              <div class="route-detail">
                <span class="route-name">{{ scope.row.productName }}</span>
                <span class="route-id">{{ scope.row.idText }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="副标题" min-width="250">
          <template slot-scope="scope">
            {{ scope.row.productSubtitle }}
          </template>
        </el-table-column>
        <el-table-column label="难度" width="60">
          <template slot-scope="scope">
            {{ scope.row.difficulty }}
          </template>
        </el-table-column>

        <el-table-column label="线路类别" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.routeTypeLabel }}</span>
          </template>
        </el-table-column>

        <el-table-column label="出发时间" width="100">
          <template slot-scope="scope">
            {{ scope.row.recentDepartureDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column label="目的地" min-width="220">
          <template slot-scope="scope">
            {{
              scope.row.destProvinceName +
              ' ' +
              scope.row.destCityName +
              scope.row.destDistrict
            }}
          </template>
        </el-table-column>

        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            {{ scope.row.sortIndex || '-' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="viewRoute(scope.row)">
              查看
            </el-button>
            <el-button type="text" @click="editRoute(scope.row)">
              编辑
            </el-button>

            <el-button
              v-if="scope.row.status === 1"
              type="text"
              @click="handleOffline(scope.row)"
            >
              下架
            </el-button>
            <el-button
              v-else-if="scope.row.status === 0 || scope.row.status === 2"
              type="text"
              @click="handleOnline(scope.row)"
            >
              上架
            </el-button>
            <el-button type="text" @click="handleSetTop(scope.row)">
              置顶
            </el-button>
            <el-button
              type="text"
              v-if="scope.row.sortIndex || scope.row.sortIndex === 0"
              @click="handleCancelTop(scope.row)"
            >
              取消置顶
            </el-button>
            <el-button
              type="text"
              v-if="scope.row.status === 0"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 置顶弹窗 -->
      <el-dialog
        title="设置置顶优先级"
        :visible.sync="topDialogVisible"
        width="400px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="topForm"
          :model="topForm"
          :rules="topRules"
          label-width="120px"
        >
          <el-form-item label="置顶优先级" prop="sortIndex">
            <el-input-number
              v-model="topForm.sortIndex"
              :min="1"
              :max="100000"
              placeholder="请输入1-100000的正整数"
              style="width: 100%"
            ></el-input-number>
            <div class="form-tip">数值越小，排名越靠前</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="topDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmSetTop" :loading="topLoading"
            >确定</el-button
          >
        </span>
      </el-dialog>

      <div class="pagination">
        <span class="pagination-info"
          >显示第 {{ (currentPage - 1) * pageSize + 1 }} 至
          {{ Math.min(currentPage * pageSize, total) }} 条，共
          {{ total }} 条记录</span
        >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Routes',
  data() {
    return {
      productName: '',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      activeTab: sessionStorage.getItem('routes_activeTab') || '1',
      routes: [],
      topDialogVisible: false,
      topForm: {
        sortIndex: ''
      },
      topRules: {
        sortIndex: [
          { required: true, message: '请输入置顶优先级', trigger: 'blur' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '请输入1-100000之间的正整数',
            trigger: 'blur'
          }
        ]
      },
      topLoading: false,
      currentProduct: null
    }
  },
  mounted() {
    // 页面加载后自动调用获取线路列表接口
    this.fetchRoutes()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchRoutes()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchRoutes()
    },
    handleCreate() {
      this.$router.push({ path: '/route-form', query: { type: '1' } })
    },
    viewRoute(route) {
      this.$router.push({
        path: '/route-form',
        query: { type: '3', productId: route.productId }
      })
    },
    editRoute(route) {
      this.$router.push({
        path: '/route-form',
        query: { type: '2', productId: route.productId }
      })
    },
    handleSearch() {
      this.fetchRoutes()
    },
    handleTabClick() {
      this.currentPage = 1
      sessionStorage.setItem('routes_activeTab', this.activeTab)
      this.fetchRoutes()
    },

    async fetchRoutes() {
      this.loading = true
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          productName: this.productName
        }
        // 如果选择了上架或下架tab，添加状态参数
        if (this.activeTab == '2') {
          params.type = 1
        } else if (this.activeTab == '0') {
          params.type = 2
          params.status = this.activeTab
        } else {
          params.status = this.activeTab
        }
        const res = await this.$http.post('product/getProductList.do', params)

        // 根据 axios 响应拦截器，code 为 '0' 或 0 表示成功
        if (res.code === '0' || res.code === 0) {
          // 根据实际接口返回结构调整数据赋值逻辑
          this.routes = res.result || []
          // 如果接口返回总条数，也需要同步更新 total
          this.total = res.total || 0
        } else {
          this.$message.error(res.message || '获取列表失败')
        }
      } catch (error) {
        console.error('获取线路列表错误:', error)
        this.$message.error('网络请求异常')
      } finally {
        this.loading = false
      }
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '下架',
        1: '上架',
        2: '待发布'
      }
      return statusMap[status] || '未知'
    },
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'danger', // 下架 - 红色
        1: 'success', // 上架 - 绿色
        2: 'warning' // 待发布 - 橙色
      }
      return typeMap[status] || ''
    },
    // 下架处理
    handleOffline(route) {
      this.$confirm('确定要下架该线路吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post(
              'product/updateProductStatus.do',
              {
                productId: route.productId || route.id,
                status: 0
              }
            )

            if (res.code === '0' || res.code === 0) {
              this.$message.success('下架成功')
              this.fetchRoutes()
            } else {
              this.$message.error(res.message || '下架失败')
            }
          } catch (error) {
            console.error('下架错误:', error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info('已取消下架')
        })
    },
    // 上架处理
    async handleOnline(route) {
      try {
        const res = await this.$http.post('product/updateProductStatus.do', {
          productId: route.productId || route.id,
          status: 1
        })

        if (res.code === '0' || res.code === 0) {
          this.$message.success('上架成功')
          this.fetchRoutes()
        } else {
          this.$message.error(res.message || '上架失败')
        }
      } catch (error) {
        console.error('上架错误:', error)
        this.$message.error('网络请求异常')
      }
    },
    // 打开置顶弹窗
    handleSetTop(route) {
      this.currentProduct = route
      this.topForm.sortIndex = route.sortIndex || ''
      this.topDialogVisible = true
      this.$nextTick(() => {
        this.$refs.topForm && this.$refs.topForm.clearValidate()
      })
    },
    // 确认置顶
    async confirmSetTop() {
      try {
        await this.$refs.topForm.validate()

        this.topLoading = true
        const res = await this.$http.post('product/setProductTopPriority.do', {
          productId: this.currentProduct.productId || this.currentProduct.id,
          sortIndex: this.topForm.sortIndex
        })

        if (res.code === '0' || res.code === 0) {
          this.$message.success('置顶成功')
          this.topDialogVisible = false
          this.fetchRoutes()
        } else {
          this.$message.error(res.message || '置顶失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('置顶错误:', error)
          this.$message.error(error.message || '网络请求异常')
        }
      } finally {
        this.topLoading = false
      }
    },
    // 取消置顶
    handleCancelTop(row) {
      this.$confirm('确定要取消置顶吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post(
              'product/setProductTopPriority.do',
              {
                productId: row.productId || row.id
                // 不传sortIndex表示取消置顶
              }
            )
            if (res.code === '0' || res.code === 0) {
              this.$message.success(res.message || '取消置顶成功')
              this.fetchRoutes()
            } else {
              this.$message.error(res.message || '取消置顶失败')
            }
          } catch (error) {
            console.error('取消置顶错误:', error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info('已取消操作')
        })
    },
    // 删除产品
    handleDelete(row) {
      this.$confirm('确定要删除该产品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      })
        .then(async () => {
          try {
            const res = await this.$http.post('product/deleteProduct.do', {
              productId: row.productId || row.id
            })
            if (res.code === '0' || res.code === 0) {
              this.$message.success(res.message || '删除成功')
              this.fetchRoutes()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            console.error('删除错误:', error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info('已取消操作')
        })
    }
  }
}
</script>

<style scoped>
.routes-page {
  padding: 20px 24px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 80px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 260px;
  border-radius: 8px;
}

.search-input .el-input__inner {
  border-radius: 8px;
  padding: 8px 12px;
}

.create-btn {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
}

.create-btn:hover {
  background: linear-gradient(135deg, #15803d 0%, #166534 100%);
}

.routes-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding: 20px;
}

/* Element UI 表格样式优化 */
.routes-container ::v-deep .el-table {
  font-size: 14px;
}

.routes-container ::v-deep .el-table th {
  background-color: #f9fafb;
  color: #6b7280;
  font-weight: 600;
}

.routes-container ::v-deep .el-table td {
  padding: 12px 0;
}

.route-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.route-image {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f3f4f6;
}

.route-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.route-detail {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.route-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}

.route-id {
  font-size: 12px;
  color: #9ca3af;
}

.difficulty-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  min-width: 48px;
}

.difficulty-tag.easy {
  background-color: #f0fdf4;
  color: #22c55e;
}

.difficulty-tag.simple {
  background-color: #f0f9ff;
  color: #3b82f6;
}

.difficulty-tag.medium {
  background-color: #fffbeb;
  color: #f59e0b;
}

.difficulty-tag.hard {
  background-color: #fef2f2;
  color: #ef4444;
}

.price {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-top: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.pagination-info {
  font-size: 13px;
  color: #6b7280;
}

.pagination .el-pagination {
  margin: 0;
}

.pagination .el-pagination button {
  border-radius: 6px;
}

.pagination .el-pagination .el-pager li.active {
  background-color: #22c55e;
  border-color: #22c55e;
  color: #fff;
}

.pagination .el-pagination .el-pager li.active:hover {
  background-color: #16a34a;
}

/* 状态标签样式强制覆盖 */
.el-tag--danger {
  background-color: #fef2f2 !important;
  color: #dc2626 !important;
  border-color: #fecaca !important;
}

.el-tag--success {
  background-color: #f0fdf4 !important;
  color: #16a34a !important;
  border-color: #bbf7d0 !important;
}

.el-tag--warning {
  background-color: #fffbeb !important;
  color: #d97706 !important;
  border-color: #fde68a !important;
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
::v-deep .el-tabs__active-bar {
  background-color: #409eff !important;
  height: 4px !important;
  border-radius: 2px !important;
}
::v-deep .el-tabs__item.is-active {
  color: #409eff !important;
  font-weight: 700;
}

::v-deep .el-tabs__item {
  font-size: 18px;
  font-weight: 400;
}
/* 操作按钮点击后状态样式 */
.el-button--text:focus,
.el-button--text:active {
  color: #606266 !important;
  background-color: transparent !important;
}

.footer-content a {
  color: #1f2937;
  text-decoration: none;
}

.footer-content a:hover {
  color: #22c55e;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>
